import { Space, Switch } from 'antd';

interface Props {
    checked: boolean;
    onChange: (checked: boolean) => void;
    loading?: boolean;
    disabled?: boolean;
}

const ShowItemsWithErrorsSwitch = ({ checked, onChange, loading, disabled }: Props) => (
    <Space size={8} align="center" style={{ marginBottom: 8 }}>
        <Switch size="small" checked={checked} onChange={onChange} loading={loading} disabled={disabled} />
        <span>Show only items with errors</span>
    </Space>
);

export default ShowItemsWithErrorsSwitch;
